<template>
	<div>
		<el-tabs v-model="tabName">
			<el-tab-pane label="ប្រភេទគម្រោង" name="first"></el-tab-pane>
			<el-tab-pane label="ប្រភេទប្រតិបត្តិការ" name="second"></el-tab-pane>
		</el-tabs>

		<!-- <div v-if="tabName == 'first'">
			<md-table>
				<md-table-row>
					<md-table-head>Setting</md-table-head>
					<md-table-head>Value</md-table-head>
					<md-table-head>Action</md-table-head>
				</md-table-row>
				<md-table-row v-for="(setting, index) in settingList">
					<md-table-cell>{{setting.name}}</md-table-cell>
					<md-table-cell>
						<md-field>
							<md-input type="text" v-model="settingList[index].value"
								:value="settingList[index].value" @keyup="">
							</md-input>
						</md-field>
					</md-table-cell>
					<md-table-cell>
						<md-button class="md-just-icon md-simple md-success">
							<md-icon>done</md-icon>
							<md-tooltip md-direction="top">Update</md-tooltip>
						</md-button>
					</md-table-cell>
				</md-table-row>
			</md-table>
		</div> -->
		<div v-if="tabName == 'second'">
			<md-table>
				<md-table-row>
					<md-table-head>រ.ល</md-table-head>
					<md-table-head>តម្លៃ</md-table-head>
					<md-table-head>សកម្មភាព</md-table-head>
				</md-table-row>
				<md-table-row v-for="(tag, index) in tagList">
					<md-table-cell>{{index+1}}</md-table-cell>
					<md-table-cell>
						<md-field>
							<md-input type="text" v-model="tagList[index].name"
								:value="tagList[index].name" @keyup="">
							</md-input>
						</md-field>
					</md-table-cell>
					<md-table-cell>
						<md-button class="md-just-icon md-simple md-success" @click="updateTag(index, tag.id)">
							<md-icon>done</md-icon>
							<md-tooltip md-direction="top">កែប្រែ</md-tooltip>
						</md-button>
					</md-table-cell>
				</md-table-row>
				<md-table-row>
					<md-table-cell>បង្កើតថ្មី</md-table-cell>
					<md-table-cell>
						<md-field>
							<md-input type="text" v-model="tag.new"
								:value="tag.new">
							</md-input>
						</md-field>
					</md-table-cell>
					<md-table-cell>
						<md-button class="md-just-icon md-simple md-success" @click="createTag()">
							<md-icon>done</md-icon>
							<md-tooltip md-direction="top">បង្កើត</md-tooltip>
						</md-button>
					</md-table-cell>
				</md-table-row>
			</md-table>
		</div>
		<!-- <md-dialog-confirm :md-active.sync="deleteDialogActive" md-title="Are you sure want to delete this ticket ?"
			md-content="By clicking OK this ticket will be deleted from the database and this action can not be undone."
			md-confirm-text="OK" md-cancel-text="Cancel" @md-cancel="onCancel" @md-confirm="onDelete" /> -->
	</div>

</template>

<script>

	export default {

		created() {
			this.getSettings();
		},
		data() {
			return {
				isValid: true,
				tabName: 'second',
				tagList: [],
				tag: {
					new: ""
				},
				settingList: [
					{
						id: "001",
						name: "Exchange rate",
						value: 4100
					}
				]
			}
		},
		methods: {
			getSettings() {
				// this.$http.get(this.config.api + "/public/location/get/list/0").then(data => {
				// 	this.locationList = data.body.data
				// })
				this.$http.get(this.config.api + "/admin/setting/data/get_all").then(data => {
					this.tagList = data.body.data.tag
				})
			},
			updateTag(index, tag_id) {
				this.$http.post(this.config.api + "/admin/setting/tag/update", {
					tag_id: tag_id,
					value: this.tagList[index].name
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "Tag was updated successfully.",
							icon: 'done',
							type: 'success'
						})
						this.getSettings();
					}
				})
			},
			createTag() {
				this.$http.post(this.config.api + "/admin/setting/tag/post", {
					tag: this.tag.new
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "Tag was created successfully.",
							icon: 'done',
							type: 'success'
						})
						this.tag.new = "";
						this.getSettings();
					}
				})
			}

		}
	}
</script>

<style scoped>
	.grid-8 {
		text-align: center;
		max-width: 12.5%;
		min-width: 12.5%;
		flex: 0 0 12.5%;
	}

	.thumb-product {
		width: 100%;
	}

	.product-thumbnail {
		width: 100px;
		height: 100px;
	}

	.vdatetime-input {
		border: 0;
		width: 100%;
		height: 32px;
	}

	.vdatetime {
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/pages/Settings/View.vue